import type { GenerateFlyerRequest, GenerateFlyerResponse } from '@pulsify/shared/dto'
import { adminBypassHeaders } from '~/app/admin-bypass'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

export const flyerApi = {
  async generate(
    businessId: string,
    file: File | null,
    params: GenerateFlyerRequest,
  ): Promise<GenerateFlyerResponse> {
    const url = api.api.businesses[':businessId']['ai-studio'].flyer.$url({
      param: { businessId },
    })
    const formData = new FormData()
    if (file) formData.append('file', file)
    formData.append('params', JSON.stringify(params))
    const token = await getAuthToken()
    const headers: Record<string, string> = { ...adminBypassHeaders() }
    if (token) headers.Authorization = `Bearer ${token}`
    const res = await fetch(url, { method: 'POST', body: formData, headers })
    return unwrap<GenerateFlyerResponse>(res)
  },
}
